import { spacing, media, color } from "@universityofmaryland/web-token-library";
import "../../typography/font-face/index.js";
import "../../typography/campaign.js";
import "../../typography/elements.js";
import { smaller } from "../../typography/sans.js";
import "../../typography/serif.js";
import "../../typography/stats.js";
import { objectWithClassName } from "../../utilities/create/jss.js";
import "../../node_modules/.pnpm/postcss@8.5.8/node_modules/postcss/lib/postcss.js";
import "../../node_modules/.pnpm/postcss-js@4.1.0_postcss@8.5.8/node_modules/postcss-js/index.js";
import "../../node_modules/.pnpm/postcss-nesting@13.0.2_postcss@8.5.8/node_modules/postcss-nesting/dist/index.js";
import "../../_virtual/index.js";
const classNamePrefix = "umd-element-event-meta";
const container = objectWithClassName({
  className: `${classNamePrefix}-container`,
  container: "inline-size",
  "+ *": {
    marginTop: `${spacing.sm}`,
    [`@media (max-width: ${media.breakpoints.small.max})`]: {
      marginTop: spacing.min
    }
  }
});
const wrapper = objectWithClassName({
  className: `${classNamePrefix}-wrapper`,
  display: "flex",
  flexWrap: "wrap",
  "> *": {
    marginRight: `5px`,
    marginTop: `5px`
  },
  "> *:not(:first-child)": {
    display: "flex",
    width: "100%"
  },
  "> *:first-child": {
    [`@container (min-width: ${media.breakpointValues.medium.max}px)`]: {
      display: "flex"
    },
    "> *": {
      display: "flex",
      alignItems: "center"
    },
    "> *:not(:first-child)": {
      [`@container (min-width: ${media.breakpointValues.medium.max}px)`]: {
        marginLeft: `${spacing.xs}`
      },
      [`@container (max-width: ${media.breakpointValues.medium.max}px)`]: {
        marginTop: `3px`
      }
    }
  }
});
const itemBase = {
  ...smaller,
  fontWeight: `400`,
  marginBottom: "0",
  "& > *:first-child": {
    width: "18px",
    display: "flex",
    [`@container (min-width: ${media.breakpointValues.large.min}px)`]: {
      width: "20px"
    }
  },
  "& svg": {
    width: "12px",
    height: "12px",
    [`@container (min-width: ${media.breakpointValues.large.min}px)`]: {
      width: "14px",
      height: "14px"
    }
  }
};
function composeItem(options) {
  const { theme = "light" } = options || {};
  const composed = {
    ...itemBase,
    color: theme === "dark" ? color.white : color.gray.dark,
    "& svg path": {
      fill: theme === "dark" ? color.white : color.gray.dark
    }
  };
  const className = theme === "dark" ? `${classNamePrefix}-item-dark` : `${classNamePrefix}-item`;
  return objectWithClassName({
    ...composed,
    className
  });
}
const item = composeItem();
const itemDark = composeItem({ theme: "dark" });
export {
  composeItem,
  container,
  item,
  itemDark,
  wrapper
};
//# sourceMappingURL=meta.js.map
